import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Vue from 'vue';
import pluginImport from '@d2-projects/vue-table-import';
Vue.use(pluginImport);
export default {
  data: function data() {
    return {
      table: {
        columns: [],
        data: [],
        size: 'mini',
        stripe: true,
        border: true
      }
    };
  },
  methods: {
    handleUpload: function handleUpload(file) {
      var _this = this;

      this.$import.csv(file).then(function (res) {
        _this.table.columns = Object.keys(res.data[0]).map(function (e) {
          return {
            label: e,
            prop: e
          };
        });
        _this.table.data = res.data;
      });
      return false;
    },
    download: function download() {
      this.$open('https://cdn.d2.pub/files/d2-admin/demo-csv.csv');
    }
  }
};